import React from 'react';
import DataType from '../types/DataType.js';

const ColumnBody = ({ column, rowIndex, rowData }) => {
    const value = rowData[column.field];
    return React.createElement("div", null, renderBody());
    function renderBody() {
        switch (column.dataType) {
            case DataType.Boolean:
                return value === true ? "True" : value === false ? "False" : "";
            case DataType.DateTime:
                return value;
            case DataType.Number:
                return value;
            case DataType.Text:
                return value;
            case DataType.Uuid:
                return value;
        }
    }
};

export { ColumnBody as default };
//# sourceMappingURL=ColumnBody.js.map
